import type { AssetStore } from './AssetStore';
import { CacheAssetStore } from './CacheAssetStore';

export function isNativeApp(): boolean {
  const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return !!cap?.isNativePlatform?.();
}

/**
 * Elige la implementación según el plan de ejecución. El módulo de Filesystem se importa de
 * forma diferida: en la PWA (Plan A) no suma ni un byte al bundle principal.
 */
export async function createAssetStore(): Promise<AssetStore> {
  if (isNativeApp()) {
    const { FilesystemAssetStore } = await import('./FilesystemAssetStore');
    return new FilesystemAssetStore();
  }
  return new CacheAssetStore();
}

export type { AssetStore } from './AssetStore';
